import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import LoginForm from './LoginForm';
import ForcedPasswordChange from './ForcedPasswordChange';
import { Loader2 } from 'lucide-react';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, loading, mustChangePassword } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4" />
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginForm />;
  }

  // Temp-password / post-reset users must set a new password before anything else.
  if (mustChangePassword) {
    return <ForcedPasswordChange />;
  }

  return <>{children}</>;
}

